// extracted by mini-css-extract-plugin
export default {"bannerAlertGM":"GiustificazioneDiMassa_bannerAlertGM__eG+MD","rigaFormGM":"GiustificazioneDiMassa_rigaFormGM__3fHkE","labelsGM":"GiustificazioneDiMassa_labelsGM__71vKN"};